<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <h1>Wonderpush</h1>  -->
    <!-- <WonderPush v-bind="options"> 
    </WonderPush>  -->

    <div class="contents">
      <router-view/>
    </div>
  </div>
</template>

<script>
//import AddGoogleMap from "./components/AddGoogleMap";
//import {WonderPush} from 'vue-wonderpush';


export default {
  name: 'app',
  components: {
    //WonderPush
  },
  data: function(){ 
  return {
    options: { 
      // webKey: "62ed3d217c0ddf1cd6e089615c60a1283890486b025a7d1a17dd12b0b40d51ea", 
      // applicationName: "LC Test", 
      // notificationDefaultUrl: "https://main.d27shrxb9oori4.amplifyapp.com", 
      // notificationIcon: "https://mcaloon.org/chat.png" } 
    } 
  }  
  }
}
</script>

<style>
/* @import url("https://fonts.googleapis.com/css?family=Material+Icons"); */
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
  /* margin-top: 60px; */
}


</style>
